import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Schedule from '../common/Schedule';
import OverviewCard from '../Overview/OverviewCard';
import VariationNumber from './VariationNumber';
import { appBasePath } from '../../constants/staticData';
import { map, findIndex } from 'lodash';
import JobsLineChart from './JobsLineChart';
import moment from 'moment';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class AllJobs extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    document.title = props.pageTitle;
    this.state = {
      searchMobile: false,
      notificationVisible: false,
      showSidebar: false,
      weekActive: true,
      monthActive: false,
    };
  }

  componentWillMount() {
    this.props.actions.openJobs("weekly");
  }

  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  render() {
    let { router, commonReducer } = this.props;
    const monthlyNewRequestData = [
      { name: '1', count: 0 },
      { name: '2', count: 0 },
      { name: '3', count: 0 },
      { name: '4', count: 0 },
      { name: '5', count: 0 },
      { name: '6', count: 0 },
      { name: '7', count: 0 },
      { name: '8', count: 0 },
      { name: '9', count: 0 },
      { name: '10', count: 0 },
      { name: '11', count: 0 },
      { name: '12', count: 0 },
      { name: '13', count: 0 },
      { name: '14', count: 0 },
      { name: '15', count: 0 },
      { name: '16', count: 0 },
      { name: '17', count: 0 },
      { name: '18', count: 0 },
      { name: '19', count: 0 },
      { name: '20', count: 0 },
      { name: '21', count: 0 },
      { name: '22', count: 0 },
      { name: '23', count: 0 },
      { name: '24', count: 0 },
      { name: '25', count: 0 },
      { name: '26', count: 0 },
      { name: '27', count: 0 },
      { name: '28', count: 0 },
      { name: '29', count: 0 },
      { name: '30', count: 0 },
      { name: '31', count: 0 },
    ];
    const monthlyExpiredData = [
      { name: '1', count: 0 },
      { name: '2', count: 0 },
      { name: '3', count: 0 },
      { name: '4', count: 0 },
      { name: '5', count: 0 },
      { name: '6', count: 0 },
      { name: '7', count: 0 },
      { name: '8', count: 0 },
      { name: '9', count: 0 },
      { name: '10', count: 0 },
      { name: '11', count: 0 },
      { name: '12', count: 0 },
      { name: '13', count: 0 },
      { name: '14', count: 0 },
      { name: '15', count: 0 },
      { name: '16', count: 0 },
      { name: '17', count: 0 },
      { name: '18', count: 0 },
      { name: '19', count: 0 },
      { name: '20', count: 0 },
      { name: '21', count: 0 },
      { name: '22', count: 0 },
      { name: '23', count: 0 },
      { name: '24', count: 0 },
      { name: '25', count: 0 },
      { name: '26', count: 0 },
      { name: '27', count: 0 },
      { name: '28', count: 0 },
      { name: '29', count: 0 },
      { name: '30', count: 0 },
      { name: '31', count: 0 },
    ];
    const monthlyInProgressData = [
      { name: '1', count: 0 },
      { name: '2', count: 0 },
      { name: '3', count: 0 },
      { name: '4', count: 0 },
      { name: '5', count: 0 },
      { name: '6', count: 0 },
      { name: '7', count: 0 },
      { name: '8', count: 0 },
      { name: '9', count: 0 },
      { name: '10', count: 0 },
      { name: '11', count: 0 },
      { name: '12', count: 0 },
      { name: '13', count: 0 },
      { name: '14', count: 0 },
      { name: '15', count: 0 },
      { name: '16', count: 0 },
      { name: '17', count: 0 },
      { name: '18', count: 0 },
      { name: '19', count: 0 },
      { name: '20', count: 0 },
      { name: '21', count: 0 },
      { name: '22', count: 0 },
      { name: '23', count: 0 },
      { name: '24', count: 0 },
      { name: '25', count: 0 },
      { name: '26', count: 0 },
      { name: '27', count: 0 },
      { name: '28', count: 0 },
      { name: '29', count: 0 },
      { name: '30', count: 0 },
      { name: '31', count: 0 },
    ];
    const newRequestData = [
      { name: 'SUN', count: 0, key: 0 },
      { name: 'MON', count: 0, key: 1 },
      { name: 'TUE', count: 0, key: 2 },
      { name: 'WED', count: 0, key: 3 },
      { name: 'THU', count: 0, key: 4 },
      { name: 'FRI', count: 0, key: 5 },
      { name: 'SAT', count: 0, key: 6 },
    ];
    const expiredData = [
      { name: 'SUN', count: 0, key: 0 },
      { name: 'MON', count: 0, key: 1 },
      { name: 'TUE', count: 0, key: 2 },
      { name: 'WED', count: 0, key: 3 },
      { name: 'THU', count: 0, key: 4 },
      { name: 'FRI', count: 0, key: 5 },
      { name: 'SAT', count: 0, key: 6 },
    ];
    const inProgressData = [
      { name: 'SUN', count: 0, key: 0 },
      { name: 'MON', count: 0, key: 1 },
      { name: 'TUE', count: 0, key: 2 },
      { name: 'WED', count: 0, key: 3 },
      { name: 'THU', count: 0, key: 4 },
      { name: 'FRI', count: 0, key: 5 },
      { name: 'SAT', count: 0, key: 6 },
    ];
    map(commonReducer.currentWeek_openJobs.newRequest, (data) => {
      if (data) {
        let key = moment(data.date).day();
        let index = findIndex(newRequestData, data => {
          return (data.key == key);
        });
        if (index > -1) {
          newRequestData[index]['count'] = data.count;
        }
        let date = moment(data.date).date();
        let monthIndex = findIndex(monthlyNewRequestData, data => {
          return (data.name == date);
        });
        if (monthIndex > -1) {
          monthlyNewRequestData[monthIndex]['count'] = data.count;
        }
      }
    });
    map(commonReducer.currentWeek_openJobs.expired, (data) => {
      if (data) {
        let key = moment(data.date).day();
        let index = findIndex(expiredData, data => {
          return (data.key == key);
        });
        if (index > -1) {
          expiredData[index]['count'] = data.count;
        }
        let date = moment(data.date).date();
        let monthIndex = findIndex(monthlyExpiredData, data => {
          return (data.name == date);
        });
        if (monthIndex > -1) {
          monthlyExpiredData[monthIndex]['count'] = data.count;
        }
      }
    });
    map(commonReducer.currentWeek_openJobs.inProgress, (data) => {
      if (data) {
        let key = moment(data.date).day();
        let index = findIndex(inProgressData, data => {
          return (data.key == key);
        });
        if (index > -1) {
          inProgressData[index]['count'] = data.count;
        }
        let date = moment(data.date).date();
        let monthIndex = findIndex(monthlyInProgressData, data => {
          return (data.name == date);
        });
        if (monthIndex > -1) {
          monthlyInProgressData[monthIndex]['count'] = data.count;
        }
      }
    });
    return (
      <div>
        <Header searchMobile={this.state.searchMobile} hideOption={() => this.setState({ searchMobile: true })} commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification} authReducer={this.props.authReducer}
          hCallback={() => { this.hclickCallBack() }} router={router} />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          <Sidebar showSidebar={this.state.showSidebar} router={router} actions={this.props.actions} commonReducer={this.props.commonReducer} authReducer={this.props.authReducer} />
          <div className="container-fluid main-container">
            <div className="col-md-9 mpad0 open-jobs">
              <div className="overview-heading">
                <h5>Open Jobs</h5>
                <ul className="open-job-period">
                  <li className={this.state.weekActive && "active"} onClick={() => { this.setState({ weekActive: true, monthActive: false }); this.props.actions.openJobs("weekly"); }}>This Week</li>
                  <li className={this.state.monthActive && "active"} onClick={() => { this.setState({ monthActive: true, weekActive: false }); this.props.actions.openJobs("monthly"); }}>This Month</li>
                </ul>
              </div>
              <JobsLineChart weekActive={this.state.weekActive} monthlyNewRequestData={monthlyNewRequestData} monthlyExpiredData={monthlyExpiredData} monthlyInProgressData={monthlyInProgressData} inProgressData={inProgressData} expiredData={expiredData} newRequestData={newRequestData} commonReducer={this.props.commonReducer} title="New Requests" clickHandler={() => router.push(`${appBasePath}/open-jobs/waiting`)} />
              <VariationNumber title="Applied" commonReducer={this.props.commonReducer} clickHandler={() => router.push(`${appBasePath}/open-jobs/applied`)} />
              <VariationNumber title="Confirmed" commonReducer={this.props.commonReducer} clickHandler={() => router.push(`${appBasePath}/open-jobs/confirmed`)} />
              <JobsLineChart weekActive={this.state.weekActive} monthlyNewRequestData={monthlyNewRequestData} monthlyExpiredData={monthlyExpiredData} monthlyInProgressData={monthlyInProgressData} inProgressData={inProgressData} expiredData={expiredData} newRequestData={newRequestData} commonReducer={this.props.commonReducer} customClass="progress-padding" title="In Progress" onlyChart="true" clickHandler={() => router.push(`${appBasePath}/open-jobs/progress`)} />
              <JobsLineChart weekActive={this.state.weekActive} monthlyNewRequestData={monthlyNewRequestData} monthlyExpiredData={monthlyExpiredData} monthlyInProgressData={monthlyInProgressData} inProgressData={inProgressData} expiredData={expiredData} newRequestData={newRequestData} commonReducer={this.props.commonReducer} title="Expired" clickHandler={() => router.push(`${appBasePath}/job-history?job_type=expired`)} />
              <VariationNumber title="Declined" commonReducer={this.props.commonReducer} clickHandler={() => router.push(`${appBasePath}/job-history?job_type=decline`)} />
            </div>
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
            </div>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OpenJobs/OpenJobs.jsx